import { create } from 'zustand';
import type { CognitoUser } from '../types/cognitoUser';

interface UserState {
  // State
  users: CognitoUser[];
  selectedUser: CognitoUser | null;
  isLoading: boolean;
  error: string | null;
  globalFilter: string;

  // Actions
  setUsers: (users: CognitoUser[]) => void;
  setSelectedUser: (user: CognitoUser | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  setGlobalFilter: (filter: string) => void;
}

export const useUserStore = create<UserState>((set) => ({
  users: [],
  selectedUser: null,
  isLoading: false,
  error: null,
  globalFilter: '',

  setUsers: (users) => set({ users }),
  setSelectedUser: (selectedUser) => set({ selectedUser }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  setGlobalFilter: (globalFilter) => set({ globalFilter }),
}));
